import React from 'react';
import Utility from "../utilities/Utility";
import ReactDOM from "react-dom";
import PropertyPanelWidget from "./PropertyPanelWidget";
import NodeRegistry from "../utilities/NodeRegistry";
import ContextMenuWidget from "./ContextMenuWidget";
import SampleDialogDataModel from "../models/dialog_editor/SampleDialogDataModel";
import UserTurnDataModel from "../models/dialog_editor/UserTurnDataModel";
import NewPromptDialog from "./dialogs/NewPromptDialog";
import NewSampleDialogDialog from "./dialogs/NewSampleDialogDialog";
import NewUserTurnDialog from "./dialogs/NewUserTurnDialog";
import VariableDataModel from "../models/VariableDataModel";
import SampleDialogPreviewDialog from "./dialogs/SampleDialogPreviewDialog";
import PromptNodeModel from "../models/nodes/PromptNodeModel";
import ReactToPrint from "react-to-print";
import Linkify from 'react-linkify';
import SystemAnnotationDataModel from "../models/dialog_editor/SystemAnnotationDataModel";
import NewSystemAnnotationDialog from "./dialogs/NewSystemAnnotationDialog";
import Button from "../form_components/Button";
import Player from "../utilities/Player";
import { getGlobalSettings } from '../stores';

const initialState = {
    id: null,
    name: "",
    description: "",
    jira: null,
    dialogs: [],
    playing: null
};

const player = new Player();

export default class DialogWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = JSON.parse(JSON.stringify(initialState));

        this.eventHandler = this.handleEvent.bind(this);
        this.printRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("ev-dialog-node-changed", this.eventHandler);
        document.addEventListener("ev-dialog-node-add", this.eventHandler);
        document.addEventListener("ev-dialog-node-remove", this.eventHandler);
        document.addEventListener("ev-dialog-node-duplicate", this.eventHandler);
        document.addEventListener("ev-dialog-changed", this.eventHandler);
        document.addEventListener("ev-dialog-variable-changed", this.eventHandler);

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover'
        });
        const treeD = $("#td_container");
        const treeV = $("#tv_container");
        treeD.jstree({
            core: {
                check_callback: function (operation, node, node_parent, node_position, more) {
                    if (operation === "move_node") {
                        return node.parent === node_parent.id;
                    }
                    return true;
                },
                data: this.modelToTreeData(window.apm.serialized.dialogs),
                multiple: true,
                themes: {
                    dots: false, // no connecting dots between dots
                    ellipsis: false,
                    stripes: false
                },
                expand_selected_onload: false,
                dnd: {
                    check_while_dragging: true,
                    large_drag_target: true,
                    large_drop_target: true
                },
                strings: {
                    "New node": "Unnamed"
                }
            },
            types: {
                folder: {
                    icon: "no-icon",
                    valid_children: ["folder", "prompt", "system", "input"]
                },
                prompt: {
                    icon: "/lib/feather/message-square.svg",
                    valid_children: []
                },
                system: {
                    icon: "/lib/feather/monitor.svg",
                    valid_children: []
                },
                input: {
                    icon: "/lib/feather/mic.svg",
                    valid_children: []
                }
            },
            search: {
                show_only_matches: true,
                search_leaves_only: true
            },
            plugins: ["types", "search", "dnd"]
        }).on("refresh.jstree", () => {
            if (this.preSelectedNode) {
                treeD.jstree().deselect_all();
                treeD.jstree().select_node(this.preSelectedNode);
                this.preSelectedNode = null;
            }
        }).on("rename_node.jstree", (e, data) => {
            const parent = this.getParentTreeNode(data.node);
            this.setDialogs(parent);
        }).on("move_node.jstree", (e, data) => {
            const model = this.treeDataToModel(treeD.jstree().get_json("#"));
            const parent = this.getParentTreeNode(data.node);

            const currentModel = model.find(uc => uc.id === parent.id);
            currentModel.lastLocalChange = window.apm.timestamp;
            window.apm.setDialogs(model);

            this.setDialogs(parent, data.node);
            treeD.jstree().deselect_all();
            treeD.jstree().select_node(data.node.id);
        }).on("delete_node.jstree", (e, data) => {
            const parent = this.getParentTreeNode(data.node);
            this.setDialogs(parent);
            treeD.jstree().deselect_all();
            this.hidePropertyPanel();
        }).on("select_node.jstree", (e, data) => {
            $(".context_menu").hide();
            const parent = this.getParentTreeNode(data.node);
            this.setDialogs(parent, data.node);

            if (data.node.type === "folder") {
                const proxyNode = new SampleDialogDataModel(data.node.data.name, {config: data.node.data}, data.node.id);
                this.showPropertyPanel(proxyNode);
            }
            if (data.node.type === "prompt") {
                const node = window.apm.getNode(data.node.data.parentComponentID);
                if (node) {
                    const proxyNode = new NodeRegistry.r[node["_class"]](node.name, 0, 0, node.props, node.id);
                    if (node["_class"] === "ModuleNodeModel") {
                        proxyNode.setProperty("ref", node.id);
                    }
                    proxyNode.setProperty("parentComponentID", node.id);
                    proxyNode.setWriteProxy(() => true);
                    this.showPropertyPanel(proxyNode);
                }
            }
            if (data.node.type === "system") {
                const proxyNode = new SystemAnnotationDataModel(data.node.id, data.node.data.name, data.node.data.description);
                this.showPropertyPanel(proxyNode);
            }
            if (data.node.type === "input") {
                const proxyNode = new UserTurnDataModel(data.node.id, data.node.data.name, data.node.data.description);
                this.showPropertyPanel(proxyNode);
            }
        }).on("contextmenu.jstree", function (e) {
            const contextContainer = $(".context_menu");
            const node = treeD.jstree().get_node(e.target);
            let nodes = treeD.jstree().is_selected(e.target) ? treeD.jstree().get_selected(true).filter(node => node.type !== "folder") : [node];
            if (nodes.length === 0) {
                nodes = [node];
            }
            treeD.jstree().deselect_all();
            treeD.jstree().select_node(nodes);
            ReactDOM.render(
                <ContextMenuWidget
                    type="dialogTreeNode"
                    context={nodes}
                    domContext={contextContainer}
                    absolute={true}
                    pos={{left: e.pageX, top: e.pageY}}/>,
                contextContainer.get(0)
            );
            e.preventDefault();
        });

        treeV.jstree({
            core: {
                check_callback: true,
                data: this.appVariableToTreeData(),
                multiple: false, // no multiselection
                themes: {
                    dots: false // no connecting dots between dots
                }
            },
            types: {
                variable: {
                    icon: "/lib/feather/hash.svg",
                    valid_children: []
                }
            },
            search: {
                show_only_matches: true,
                search_leaves_only: true
            },
            plugins: ["types", "search", "sort"]
        }).on("select_node.jstree", (e, data) => {
            const node = window.apm.getNode(data.node.id);
            const proxyNode = new VariableDataModel(node.props, node.id);
            proxyNode.setWriteProxy(() => true);
            this.showPropertyPanel(proxyNode);
        }).on("contextmenu.jstree", function (e) {
            const contextContainer = $(".context_menu");
            const node = treeV.jstree().get_node(e.target);
            if (!node) return;
            ReactDOM.render(
                <ContextMenuWidget
                    type="treeNode"
                    context={[node]}
                    domContext={contextContainer}
                    absolute={true}
                    pos={{left: e.pageX, top: e.pageY}}/>,
                contextContainer.get(0)
            );
            e.preventDefault();
        });

        const dialogTree = $("#dialog_tree");
        const variableTree = $("#variable_tree");

        function updateTreeviews() {
            const baseMarginTop = 10,
                baseMarginBottom = 30,
                baseSpacer = 8;
            const baseTop = 110 + baseMarginTop;
            const maxHeight = $(document).height() - baseTop - baseMarginBottom - baseSpacer;
            const dBaseHeight = 84;
            const vBaseHeight = 84;

            dialogTree.css("top", baseTop);
            var dNewHeight = 0,
                vNewHeight = 0,
                vNewTop = 0;
            if (dialogTree.data("open")) {
                if (variableTree.data("open")) {
                    dNewHeight = maxHeight / 2;
                    vNewHeight = maxHeight / 2;
                    vNewTop = baseTop + maxHeight / 2 + baseSpacer;
                } else {
                    dNewHeight = maxHeight - vBaseHeight;
                    vNewHeight = vBaseHeight;
                    vNewTop = baseTop + maxHeight - vBaseHeight + baseSpacer;
                }
            } else {
                if (variableTree.data("open")) {
                    dNewHeight = dBaseHeight;
                    vNewHeight = maxHeight - dBaseHeight;
                    vNewTop = baseTop + dBaseHeight + baseSpacer;
                } else {
                    dNewHeight = dBaseHeight;
                    vNewHeight = vBaseHeight;
                    vNewTop = baseTop + dBaseHeight + baseSpacer;
                }
            }
            dialogTree.css("height", dNewHeight);
            variableTree.css({height: vNewHeight, top: vNewTop});
            dialogTree
                .children(".tree-container")
                .css("height", dNewHeight - dBaseHeight);
            variableTree
                .children(".tree-container")
                .css("height", vNewHeight - vBaseHeight);

            if (dialogTree.data("open")) {
                dialogTree
                    .find(".title-prefix-icon > i")
                    .removeClass("icon-chevrons-down")
                    .addClass("icon-chevrons-up");
            } else {
                dialogTree
                    .find(".title-prefix-icon > i")
                    .removeClass("icon-chevrons-up")
                    .addClass("icon-chevrons-down");
            }
            if (variableTree.data("open")) {
                variableTree
                    .find(".title-prefix-icon > i")
                    .removeClass("icon-chevrons-down")
                    .addClass("icon-chevrons-up");
            } else {
                variableTree
                    .find(".title-prefix-icon > i")
                    .removeClass("icon-chevrons-up")
                    .addClass("icon-chevrons-down");
            }
        }

        dialogTree.data("open", true);
        variableTree.data("open", false);
        updateTreeviews();

        dialogTree.find("#tree_title").on("click", function (event) {
            if ($(event.target).closest(".title-suffix-icon").length) {
                return;
            }
            const newOpen = !dialogTree.data("open");
            if (newOpen) {
                dialogTree.children(".tree-container").show();
            } else {
                dialogTree.children(".tree-container").hide();
            }
            dialogTree.data("open", newOpen);
            updateTreeviews();
        });
        variableTree.find(".tree-title").on("click", event => {
            if ($(event.target).hasClass("icon-button")) {
                window.apm.popup("New application variable",
                    '<div class="new_variable_container"></div>',
                    // CM TODO: unMount this.propertyPanelWidget
                    '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                    '<button class="w2ui-btn primary add-button">Add</button> ',
                    [
                        ".new_variable_container",
                        () => {
                            const tempNode = new VariableDataModel();
                            tempNode.isEmbed = true;
                            this.propertyPanelWidget = ReactDOM.render(
                                <PropertyPanelWidget 
                                context={tempNode} 
                                embed={true}/>, 
                            $(".new_variable_container").get(0));
                            $(".w2ui-popup").find(".add-button").on("click", function () {
                                const variable = {
                                    "id": tempNode.getID(),
                                    "name": tempNode.getConfig("name"),
                                    "type": "variable",
                                    "_class": "VariableDataModel",
                                    "props": tempNode.props
                                };
                                window.apm.addNode(variable);
                                $("#tl_container").jstree().create_node("variables", Utility.getTreeNode(variable), "last");
                                document.dispatchEvent(new CustomEvent("ev-dialog-variable-changed"));
                                w2popup.close();
                            });
                        
                        }
                    ], 
                    500
                );
                return;
            }
            const newOpen = !variableTree.data("open");
            if (newOpen) {
                variableTree.children(".tree-container").show();
            } else {
                variableTree.children(".tree-container").hide();
            }
            variableTree.data("open", newOpen);
            updateTreeviews();
        });

        $("#td_search").on("change keyup paste", function (e) {
            const searchInput = $("#td_q");
            $("#td_container").jstree(true).search(searchInput.val());
            if (!dialogTree.data("open")) {
                dialogTree.children(".tree-container").show();
                dialogTree.data("open", true);
                updateTreeviews();
            }
            if (searchInput.val() && searchInput.val().length) {
                $(this).find(".clear-button").show();
            } else {
                $(this).find(".clear-button").hide();
            }
        });
        $("#td_search")
            .find(".clear-button")
            .on("click", function () {
                $("#td_q").val("");
                $("#td_search").trigger("change");
                $(this).hide();
            });
        $("#tv_search").on("change keyup paste", function (e) {
            const searchInput = $("#tv_q");
            $("#tv_container").jstree(true).search(searchInput.val());
            if (!variableTree.data("open")) {
                variableTree.children(".tree-container").show();
                variableTree.data("open", true);
                updateTreeviews();
            }
            if (searchInput.val() && searchInput.val().length) {
                $(this).find(".clear-button").show();
            } else {
                $(this).find(".clear-button").hide();
            }
        });
        $("#tv_search")
            .find(".clear-button")
            .on("click", function () {
                $("#tv_q").val("");
                $("#tv_search").trigger("change");
                $(this).hide();
            });

        this.updateDom();
        $(window).on("resize", () => {
            this.updateDom();
            updateTreeviews();
        });
    }

    componentWillUnmount() {
        document.removeEventListener("ev-dialog-node-changed", this.eventHandler);
        document.removeEventListener("ev-dialog-node-add", this.eventHandler);
        document.removeEventListener("ev-dialog-node-remove", this.eventHandler);
        document.removeEventListener("ev-dialog-node-duplicate", this.eventHandler);
        document.removeEventListener("ev-dialog-changed", this.eventHandler);
        document.removeEventListener("ev-dialog-variable-changed", this.eventHandler);
    }

    getParentTreeNode(current) {
        const treeD = $("#td_container");
        if (current.parent === "#") {
            return treeD.jstree().get_node(current.id);
        } else {
            return treeD.jstree().get_node(current.parent);
        }
    }

    handleEvent(event) {
        const treeD = $("#td_container");
        const treeV = $("#tv_container");
        const lang = getGlobalSettings().language;
        if (event.type === "ev-dialog-node-changed") {
            const dialogs = treeD.jstree().get_json("#");
            for (let i = 0; i < dialogs.length; i++) {
                const d = dialogs[i];
                if (d.id === event.detail.id) {
                    const n = treeD.jstree().get_node(d.id);
                    n.data = event.detail;
                    treeD.jstree().rename_node(n.id, this.getTreeNodeText(n.data));
                }
                for (let j = 0; j < d.children.length; j++) {
                    const c = d.children[j];
                    if (c.id === event.detail.id) {
                        const n = treeD.jstree().get_node(c.id);
                        n.data.description = event.detail.text;
                        treeD.jstree().rename_node(n.id, this.getTreeNodeText(n.data));
                    }
                    if (c.data.parentComponentID === event.detail.id) {
                        const n = treeD.jstree().get_node(c.id);
                        n.data.name = event.detail.name;
                        n.data.description = event.detail.props.config.text[lang];
                        treeD.jstree().rename_node(n.id, this.getTreeNodeText(n.data));
                    }
                }
            }
        }
        if (event.type === "ev-dialog-node-add") {
            const type = event.detail.type;
            if (type === "folder") {
                if (!event.detail.node) {
                    window.apm.popup("New sample dialog",
                        '<div class="new_dialog_container"></div>',
                        '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                        '<button class="w2ui-btn primary add-button">Add sample dialog</button> ',
                        [
                            ".new_dialog_container",
                            () => {
                                ReactDOM.render(<NewSampleDialogDialog/>, $(".new_dialog_container").get(0));
                                $(".w2ui-popup").find(".add-button").on("click", function () {
                                    document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                                });
                            
                            }
                        ]
                        
                    );
                    return;
                }
                treeD.jstree().close_all();
                const dialog = event.detail.node.serialize();
                window.apm.addDialog(dialog);
                this.preSelectedNode = dialog.id;
                treeD.jstree().settings.core.data = this.modelToTreeData(window.apm.serialized.dialogs);
                treeD.jstree().refresh();
                return;
            }
            const selected = treeD.jstree().get_selected(true);
            if (selected.length) {
                let parent;
                if (selected[0].parent === "#") {
                    parent = treeD.jstree().get_node(selected[0].id);
                } else {
                    parent = treeD.jstree().get_node(selected[0].parent);
                }
                const insertIdx = selected[0].type === "folder" ? parent.children.length : (parent.children.findIndex(c => c === selected[0].id) + 1);
                let node;
                if (type === "system") {
                    if (!event.detail.node) {
                        window.apm.popup("New system annotation",
                            '<div class="new_dialog_container"></div>',
                            '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                            '<button class="w2ui-btn primary add-button">Add system annotation</button> ',
                            [
                                ".new_dialog_container",
                                () => {
                                    ReactDOM.render(<NewSystemAnnotationDialog/>, $(".new_dialog_container").get(0));
                                    $(".w2ui-popup").find(".add-button").on("click", function () {
                                        document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                                    });
                                
                                }
                            ], 
                            400
                        );
                        return;
                    }
                    node = {
                        id: Utility.uuid4(),
                        type: "system",
                        text: event.detail.node.text,
                    };
                }
                if (type === "input") {
                    if (!event.detail.node) {
                        window.apm.popup("New user turn",
                            '<div class="new_dialog_container"></div>',
                            '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                            '<button class="w2ui-btn primary add-button">Add user turn</button> ',
                            [
                                ".new_dialog_container",
                                () => {
                                    ReactDOM.render(<NewUserTurnDialog/>, $(".new_dialog_container").get(0));
                                    $(".w2ui-popup").find(".add-button").on("click", function () {
                                        document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                                    });
                                
                                }
                            ], 
                            400
                        );
                        return;
                    }
                    node = {
                        id: Utility.uuid4(),
                        type: "input",
                        text: event.detail.node.text,
                    };
                }
                if (type === "prompt") {
                    if (!event.detail.node) {
                        window.apm.popup("New prompt",
                            '<div class="new_dialog_container"></div>',
                            '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                            '<button class="w2ui-btn primary add-button">Add Prompt</button> ',
                            [
                                ".new_dialog_container",
                                () => {
                                    ReactDOM.render(<NewPromptDialog/>, $(".new_dialog_container").get(0));
                                    $(".w2ui-popup").find(".add-button").on("click", function () {
                                        document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                                    });
                                
                                }    
                            ], 
                            500
                        );
                        return;
                    }
                    node = {
                        id: Utility.uuid4(),
                        type: "prompt",
                        parentComponentID: event.detail.node.id,
                    };
                }
                if (node) {
                    window.apm.addDialogNode(parent.id, node, insertIdx);
                    this.preSelectedNode = node.id;
                    treeD.jstree().settings.core.data = this.modelToTreeData(window.apm.serialized.dialogs);
                    treeD.jstree().refresh();
                }
            }
        }
        if (event.type === "ev-dialog-node-remove") {
            window.apm.removeDialog(event.detail);
            treeD.jstree().delete_node(event.detail);
        }
        if (event.type === "ev-dialog-node-duplicate") {
            const dialogs = window.apm.serialized.dialogs;
            const dIdx = dialogs.findIndex(d => d.id === event.detail);
            const dialog = dialogs[dIdx];
            if (dialog) {
                const copied = JSON.parse(JSON.stringify(dialog));
                copied.id = Utility.uuid4();
                copied.name += " copy";
                copied.nodes.forEach(n => {
                    n.id = Utility.uuid4();
                });
                window.apm.addDialogNode(dialog.id, copied, dIdx + 1);
                this.preSelectedNode = copied.id;
                treeD.jstree().close_all();
                treeD.jstree().settings.core.data = this.modelToTreeData(window.apm.serialized.dialogs);
                treeD.jstree().refresh();
            }
        }
        if (event.type === "ev-dialog-changed") {
            if (!treeD.jstree().get_selected(true)[0]) {
                this.preSelectedNode = treeD.jstree().get_node(this.state.id);
            }
            treeD.jstree().settings.core.data = this.modelToTreeData(window.apm.serialized.dialogs);
            treeD.jstree().refresh();
        }
        if (event.type === "ev-dialog-variable-changed") {
            treeV.jstree().settings.core.data = this.appVariableToTreeData();
            treeV.jstree().refresh();
        }
    }

    getTreeNodeText(data) {
        const escapedName = $("<div/>").text(data.name).html();
        const escapedDesc = $("<div/>").text(data.description).html();
        return `<div><p class="title">${escapedName}</p><p class="subtitle">${data.description ? escapedDesc : "No value"}</p></div>`;
    }

    appVariableToTreeData() {
        return window.apm.serialized.components.variables.map(v => {
            return Utility.getTreeNode(v);
        });
    }

    modelToTreeData(model) {
        const treeData = [];
        const brokenRefs = [];
        model.forEach(uc => {
            const data = uc;
            const folder = {
                id: uc.id,
                data: data,
                text: this.getTreeNodeText(data),
                type: "folder",
                children: []
            };
            uc.nodes.forEach(n => {
                let data;
                if (n.type === "prompt") {
                    const node = window.apm.getNode(n.parentComponentID);
                    if (node) {
                        data = {
                            name: node.name,
                            description: "",
                            parentComponentID: n.parentComponentID
                        };
                        if (node._class === "PromptNodeModel") {
                            const lang = getGlobalSettings().language;
                            data.description = node.props.config.text[lang];
                        }
                    } else {
                        // remove broken reference
                        brokenRefs.push(n.id);
                    }
                }
                if (n.type === "system") {
                    data = {
                        name: "SYSTEM ANNOTATION",
                        description: n.text,
                    };
                }
                if (n.type === "input") {
                    data = {
                        name: "USER TURN",
                        description: n.text,
                    };
                }
                if (data) {
                    folder.children.push({
                        id: n.id,
                        data: data,
                        text: this.getTreeNodeText(data),
                        type: n.type,
                        children: []
                    });
                }
            });
            treeData.push(folder);
        });
        brokenRefs.forEach(id => {
            window.apm.removeDialog(id);
        });
        return treeData;
    }

    treeDataToModel(treeData) {
        const model = [];
        for (let i = 0; i < treeData.length; i++) {
            const d = treeData[i];
            const uc = {
                id: d.id,
                name: d.data.name,
                description: d.data.description,
                substitutions: d.data.substitutions,
                createdTime: d.data.createdTime,
                lastLocalChange: d.data.lastLocalChange,
                nodes: []
            };
            for (let j = 0; j < d.children.length; j++) {
                const c = d.children[j];
                const node = {
                    id: c.id,
                    type: c.type
                };
                if (c.type === "prompt") {
                    node.parentComponentID = c.data.parentComponentID;
                }
                if (c.type === "system" || c.type === "input") {
                    node.text = c.data.description;
                }
                uc.nodes.push(node);
            }
            model.push(uc);
        }
        return model;
    }

    updateDom() {
        $("#dialog_property").css({
            "height": $(document).height() - 150
        });
    }

    setDialogs(parent, current = null) {
        const tree = $("#td_container");
        const dialogs = [];
        const substitutions = parent.data.substitutions ? parent.data.substitutions : {};
        parent.children.forEach((c, cIdx) => {
            const child = tree.jstree().get_node(c);
            let text = child.data.description + " ";
            if (child.type === "prompt") {
                Object.keys(substitutions).forEach(v => {
                    const sub = substitutions[v];
                    if (sub) {
                        text = text.replace(new RegExp(`{{${v}}}`, "g"), sub);
                    }
                });
            }
            const ttsText = text.replace(/{{.*}}/, "blank");
            const line = <span key={child.id + cIdx} className={child.type === "system" ? "system" : ""}>{text}</span>;
            const lineType = child.type === "system" ? "prompt" : child.type;
            if (dialogs.length === 0 || dialogs[dialogs.length - 1].type !== lineType) {
                dialogs.push({
                    lines: [line],
                    type: lineType,
                    ids: [child.id],
                    text: ttsText
                });
            } else {
                const last = dialogs[dialogs.length - 1];
                last.lines.push(line);
                last.ids.push(child.id);
                last.text += child.type === "system" ? "" : ttsText;
            }
            if (child.type === "prompt") {
                const prompt = window.apm.getNode(child.data.parentComponentID);
                if (prompt && prompt.props.config.inputs) {
                    prompt.props.config.inputs.forEach(i => {
                        if (i && i.varName && !substitutions.hasOwnProperty(i.varName)) {
                            substitutions[i.varName] = "";
                        }
                    });
                }
            }
        });
        dialogs.forEach(d => {
            if (current && d.ids.indexOf(current.id) > -1) {
                d.classes = d.type + " selected";
            } else {
                d.classes = d.type;
            }
        });
        this.setState({
            ...parent.data,
            dialogs: dialogs
        });
    }

    getVoice(dialog) {
        if (dialog.type === "prompt") {
            return this.state.promptVoice || 1099511628260;
        }
        return this.state.inputVoice || 1099511628298;
    }

    playDialogs() {
        const treeD = $("#td_container");
        const selected = treeD.jstree().get_selected(true)[0];
        if (selected) {
            const parent = this.getParentTreeNode(selected);
            this.setDialogs(parent);
        }
        treeD.jstree().deselect_all();
        this.hidePropertyPanel();

        // promise queue
        let queue = Promise.resolve();
        const dialogs = this.state.dialogs;
        dialogs.forEach(d => {
            // add dialogs to the queue
            queue = queue.then(() => {
                this.setState({playing: d.text});
                return player.play(d.text, this.getVoice(d));
            });
        });
        // play dialogs
        queue.catch(() => Promise.resolve()).then(() => {
            this.setState({playing: null});
        });
    }

    showPropertyPanel(model) {
        const panel = $("#dialog_property");
        
        this.propertyPanelWidget = ReactDOM.render(<PropertyPanelWidget 
            panelDOM={panel}
            context={model}
            embed={true}
            />, panel.get(0));
        
        this.propertyPanelWidget.showPropertyPanel();
    }

    hidePropertyPanel() {
        const panel = $("#dialog_property");
        $("#dialog_property").css("right", "-500px");
        this.propertyPanelWidget = ReactDOM.unmountComponentAtNode(panel.get(0));
    }

    render() {
        return (
            <div id="dialog_editor">
                <div id="dialog_tree" className="dialog-tree">
                    <form id="td_search" autoComplete="off">
                        <div id="tree_title" className="tree-title">
                            <button className="title-prefix-icon tree-title-button" onClick={event => {
                                event.preventDefault();
                            }}>
                                <i className="fe icon-chevrons-up"/>
                            </button>
                            <span className="tree-title-text">SAMPLE DIALOGS</span>
                            <div className="title-suffix-icon">
                                <button className="icon-button" data-toggle="tooltip" data-placement="bottom" title="Present"
                                        onClick={event => {
                                            event.preventDefault();
                                            player.stop(true);
                                            window.apm.popup("Preview",
                                                '<div class="dialog_preview_container"></div>',
                                                '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                                                '<div id="print_container" /> ',
                                                [
                                                    ".dialog_preview_container",
                                                    () => {
                                                        ReactDOM.render(<SampleDialogPreviewDialog ref={this.printRef} />, $(".dialog_preview_container").get(0));
                                                        ReactDOM.render(<ReactToPrint
                                                            trigger={() => <button className="w2ui-btn primary add-button">Print</button>}
                                                            content={() => this.printRef.current}
                                                        />, $(".w2ui-popup").find(".w2ui-popup-buttons").get(0));
                                                    
                                                        setTimeout(() => {
                                                            w2popup.max();
                                                        }, 150);
                                                    }
                                                ]
                                                
                                            );
                                        }}>
                                    <i className="fe icon-monitor" />
                                </button>
                                <button className="icon-button"
                                        onClick={event => {
                                            event.preventDefault();
                                            const contextContainer = $(".context_menu");
                                            ReactDOM.render(
                                                <ContextMenuWidget
                                                    type="treeTitle"
                                                    context="dialogs"
                                                    domContext={contextContainer}
                                                    absolute={true}
                                                    pos={{left: event.pageX, top: event.pageY}}/>,
                                                contextContainer.get(0)
                                            );
                                        }}>+
                                </button>
                            </div>
                        </div>
                        <div>
                            <i className="fe icon-search input-prefix-icon"/>
                            <i className="fe icon-x input-suffix-icon clear-button"/>
                            <input type="search" id="td_q" placeholder={window.l.popup.search}
                                   className="form-component v-marginal search"/>
                        </div>
                    </form>
                    <div id="td_container" className="tree-container"></div>
                </div>
                <div id="variable_tree" className="dialog-tree">
                    <form id="tv_search" autoComplete="off">
                        <div className="tree-title">
                            <button className="title-prefix-icon tree-title-button" onClick={event => {
                                event.preventDefault();
                            }}>
                                <i className="fe icon-chevrons-up"/>
                            </button>
                            <span className="tree-title-text">APP VARIABLES</span>
                            <div className="title-suffix-icon">
                                <button className="icon-button"
                                        onClick={event => {
                                            event.preventDefault();
                                        }}>+
                                </button>
                            </div>
                        </div>
                        <div>
                            <i className="fe icon-search input-prefix-icon"/>
                            <i className="fe icon-x input-suffix-icon clear-button"/>
                            <input type="search" id="tv_q" placeholder={window.l.popup.search}
                                   className="form-component v-marginal search"/>
                        </div>
                    </form>
                    <div id="tv_container" className="tree-container"></div>
                </div>
                <div id="dialog_main" className="dialog-container">
                    <div className="top">
                        <div className="header">
                            <h4>Dialogs Preview</h4>
                            {(this.state.name && this.state.name.length > 0) && <div>
                                {!this.state.playing && <Button label="Play Dialog" callback={() => {
                                    this.playDialogs();
                                }}/>}
                                {this.state.playing && <Button label="Stop Playing" tint={"warning"} callback={() => {
                                    player.stop(true);
                                }}/>}
                            </div>}
                        </div>
                        <hr/>
                        {(this.state.name && this.state.name.length > 0) && <div className="title">
                            <p className="dialog-name">{this.state.name}</p>
                            {this.state.jira &&
                            <a href={"https://jira.interactions.net/browse/" + this.state.jira} target="_blank">
                                <i className="fe icon-external-link"/>
                            </a>}
                        </div>}
                        {!this.state.name &&
                        <p className="dialog-name">Create or select a Sample Dialog from the left to get started.</p>}
                        <p className="description"><Linkify componentDecorator={(href, text, key) => (
                            <a href={href} key={key} target="_blank">
                                {text}
                            </a>
                        )}>{this.state.description}</Linkify></p>
                    </div>
                    <table><tbody>
                    {this.state.dialogs.length > 0 && this.state.dialogs.map((d, idx) => {
                        return <tr key={this.state.name + idx}>
                            {d.text === this.state.playing && <td className="action playing">
                                <i className="fe icon-stop-circle" onClick={() => {
                                    player.stop(true);
                                }}/>
                            </td>}
                            {d.text !== this.state.playing && <td className={"action"}>
                                {!this.state.playing && <i className="fe icon-play-circle" onClick={() => {
                                    this.setState({playing: d.text});
                                    return player.play(d.text, this.getVoice(d)).catch(() => Promise.resolve()).then(() => {
                                        this.setState({playing: null});
                                    });
                                }}/>}
                            </td>}
                            <td><p className={"preview " + d.classes}>{d.lines}</p></td>
                        </tr>
                    })}
                    </tbody></table>
                </div>
                <div id="dialog_property"></div>
            </div>
        )
    }
}

